<script setup>
  import {computed} from "vue";

  import ComponentIcon from "@components/Icons/Icon.vue";
  import {Link as InertiaLink} from "@inertiajs/vue3";
  import {cn} from "@pharma4u/medicheck-components/utils";

  defineOptions({
    name: "AuthHeaderDropdownItem",
  });

  const props = defineProps({
    label: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    href: {
      type: String,
      default: null,
    },
    data: {
      type: Object,
      default: null,
    },
    canBeActive: {
      type: Boolean,
      default: true,
    },
    isExternal: {
      type: Boolean,
      default: false,
    },
  });

  const isActive = computed(() => {
    if (!props.href || !props.canBeActive || props.isExternal) return false;

    try {
      const currentPath = globalThis.location.pathname;
      const hrefPath = new URL(props.href).pathname;
      return currentPath.startsWith(hrefPath);
    } catch {
      return false;
    }
  });
</script>

<template>
  <component
    :is="href && !isExternal ? InertiaLink : 'a'"
    v-bind="$attrs"
    :href="href"
    :target="isExternal ? '_blank' : ''"
    :class="
      cn('group block w-full cursor-pointer items-start rounded-lg p-2 no-underline! focus:ring-4 focus:ring-red-300', {
        'bg-gray-100 text-gray-900': isActive,
        'text-gray-500 hover:bg-gray-100 hover:text-gray-900': !isActive,
      })
    "
    :data-test="getTestId(`item-${href ? (isExternal ? 'link' : 'inertia-link') : 'button'}`)"
  >
    <div class="items-top flex space-x-2">
      <ComponentIcon v-if="icon" class="p-1 text-xl" :class="{'text-mcred': isActive}">{{ icon }}</ComponentIcon>
      <div>
        <div class="flex items-center space-x-1.5">
          <span class="text-left font-semibold">{{ label }}</span>

          <ComponentIcon
            v-if="isExternal"
            class="grouplink:no-underline text-sm leading-tight text-gray-500 group-hover:text-gray-900"
            :clickable="true"
            title="Öffnet in neuem Tab"
          >
            launch
          </ComponentIcon>
        </div>

        <p v-if="description" class="mt-0.5 text-sm">
          {{ description }}
        </p>
      </div>
    </div>
  </component>
</template>
